export const CONTENT_TRACK_CLASS = "mx-auto w-[calc(100vw-32px)] max-w-7xl sm:w-[calc(100vw-48px)]";
export const STUDIO_SECTION_CLASS = "min-h-dvh w-full bg-black pb-10 pt-24 lg:pl-56";
export const STUDIO_CONTENT_SHELL_CLASS =
  "mx-auto grid w-[calc(100vw-32px)] max-w-[92rem] gap-y-5 sm:w-[calc(100vw-48px)] lg:w-[calc(100vw-14rem-48px)]";
export const STUDIO_MAIN_CLASS = "mx-auto w-full min-w-0 max-w-7xl";
export const STUDIO_HEADER_CLASS =
  "flex min-h-[4.5rem] flex-col justify-between gap-4 border-b border-white/20 pb-5 sm:flex-row sm:items-end";
export const STUDIO_EYEBROW_CLASS = "flex items-center gap-2 text-sm font-medium text-zinc-400";
export const STUDIO_TITLE_CLASS = "mt-2 text-2xl font-semibold tracking-normal text-white";
export const STUDIO_PANEL_CLASS = "rounded-md border border-white/20 bg-black";
export const STUDIO_DETAIL_GRID_CLASS = "grid divide-y divide-white/20 border-y border-white/20 sm:divide-x sm:divide-y-0";
export const STUDIO_DETAIL_CELL_CLASS = "px-3 py-3";
export const STUDIO_SECONDARY_BUTTON_CLASS =
  "inline-flex h-10 w-fit items-center justify-center gap-2 rounded-md border border-white/20 bg-black px-4 text-sm font-semibold text-zinc-200 transition-colors hover:bg-white hover:text-black focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black";
export const PRIMARY_CTA_BUTTON_CLASS =
  "border-white !bg-white !text-black hover:!bg-black hover:!text-white";
export const AUTH_TOGGLE_BUTTON_CLASS =
  "h-10 rounded-md border text-sm font-semibold transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-black";
export const AUTH_TOGGLE_ACTIVE_CLASS =
  "border-white bg-white text-black";
export const AUTH_TOGGLE_INACTIVE_CLASS = "border-transparent text-zinc-300 hover:bg-white hover:text-black";
export const BRAND_LAYOUT_ID = "qingnest-wordmark";
export const LAST_HOME_PAGE_INDEX = 1;
export const HERO_VANISH_FALLBACK_MS = 2800;
